<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Coupon Campaigns</h2>
          </div>
          <!-- Coupon Listing-->
          <div class="body pt-0">
            <div
              class="chart-top-action d-lg-flex justify-content-between py-3"
            >
              <div class="d-md-flex justify-content-between">
                <div class="mr-0 mr-md-3 action-top-search">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search partner"
                      aria-label="Search partner"
                      aria-describedby="search-partner"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text" id="search-mail">
                        <i class="icon-magnifier"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <b-button
                    size="lg"
                    variant="primary btn-mw"
                    @click="addCoupon()"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </b-button>
                </div>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Coupon List -->
            <b-table
              responsive
              ref="customerTable"
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(users)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span
                    class="badge badge-info ml-0"
                    v-for="(item, index) in data.value"
                    :key="index"
                  >
                    {{ item ? item : "-" }}
                  </span>
                  <span v-if="data.value.length == 0">-</span>
                </p>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EmailCouponComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  methods: {
    addCoupon() {
      this.$router.push({ path: "/coupon-managment/email-coupon/create" });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
  },
  data() {
    return {
      items: [
        {
          coupon_code: "WELCOME",
          sent_date: "2024-05-20",
          user_count: 2,
          users: ["Lusifer Boswell", "Mark Richards"],
        },
        {
          coupon_code: "FREE50",
          sent_date: "2024-04-10",
          user_count: 3,
          users: ["Robert Evans", "Lusifer Boswell", "Mark Richards"],
        },
        {
          coupon_code: "HELLO150",
          sent_date: "2023-11-29",
          user_count: 4,
          users: [
            "Robert Evans",
            "Selena Parker",
            "Lusifer Boswell",
            "Mark Richards",
          ],
        },
        {
          coupon_code: "WELCOME",
          sent_date: "2022-08-25",
          user_count: 1,
          users: ["Selena Parker"],
        },
        {
          coupon_code: "TRY200",
          sent_date: "2022-11-16",
          user_count: 0,
          users: [],
        },
      ],

      fields: [
        {
          key: "coupon_code",
          label: "Coupon Code",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "user_count",
          label: "Count of Users",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "users",
          label: "Sent to Users",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "sent_date",
          label: "Sent date",
          sortable: true,
          thClass: "th_sortfix",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  mounted() {
    this.totalRows = this.items.length;
  },
};
</script>
